module.exports = __webpack_public_path__ + "img/star-notfy.f037c59f.svg";